/**************************************************
 * Nombre:       Datos_Pago
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {formatoMoneda} from "../../../../Utilidades/formatoMoneda";

const Datos_Pago = ({item}) => {

    const TituloTexto = ({titulo, texto}) => {
        return (
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                size={12}
            >

                <Grid item container size={{xs: 4, sm: 2, md: 2}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 16, fontWeight: 600}}>{titulo}</Typography>
                </Grid>

                <Grid item container size={{xs: 8, sm: 10, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 16, fontWeight: 400}}>{texto}</Typography>
                </Grid>

            </Grid>
        )
    }

    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            size={12}
        >

            <Grid item container size={12} sx={{justifyContent: 'flex-start'}}>
                <TituloTexto titulo={'Nombre:'} texto={item.nombre}/>
            </Grid>

            <Grid item container size={12} sx={{justifyContent: 'flex-start'}}>
                <TituloTexto titulo={'Descripcion:'} texto={item.descripcion}/>
            </Grid>

            <Grid item container size={12} sx={{justifyContent: 'flex-start'}}>
                <TituloTexto titulo={'Valor:'} texto={`${formatoMoneda(item.valor, 0)} COP`}/>
            </Grid>

        </Grid>
    )

}
export default Datos_Pago